import { useMemo } from 'react';
import { hasMultipleBillingTerms } from 'pricing-pages-ui-hsoc/components/merch-card-grid/HsocMerchCardPrice';
import { resolveHsocCardBadges } from 'pricing-pages-ui-hsoc/components/merch-card-grid/hsocCardBadges';
import { usePlanQuizState } from 'pricing-pages-ui-hsoc/components/plan-quiz/PlanQuizContext';
import { getRecommendedTierName } from 'pricing-pages-ui-hsoc/components/plan-quiz/planQuizConstants';
import { getPresentHsocTierNames, isHsocTierName } from './hsocPublicTiers';
import { mapProductsByTierToCards } from './hsocPublicCards';
import { useHsocPublicLimitedTimeOfferByTier } from './hooks/useHsocPublicLimitedTimeOffer';
/*
 * Maps shared tier options (owned by the page via useHsocPublicTierOptions, so
 * the tier query, its loading, and its error live in one place) into the merch
 * card props. selectedTerm is controlled by the page so the cards and the
 * feature-table plan-details stay in sync with the billing-term toggle.
 * Mirrors the in-app useHsocInAppPricing.
 */
export function useHsocPublicPricing(tierOptions, currencyCode, selectedTerm) {
  var _productsByTier$START;
  const {
    productsByTier
  } = tierOptions;
  const tiers = useMemo(() => {
    if (!productsByTier) {
      return [];
    }
    return getPresentHsocTierNames(productsByTier).map(tierName => ({
      tierName,
      productApiName: productsByTier[tierName].productApiName
    }));
  }, [productsByTier]);
  const starterApiName = productsByTier === null || productsByTier === void 0 || (_productsByTier$START = productsByTier.STARTER) === null || _productsByTier$START === void 0 ? void 0 : _productsByTier$START.productApiName;
  const limitedTimeOfferDiscountByTierName = useHsocPublicLimitedTimeOfferByTier(starterApiName, selectedTerm);
  const {
    recommendation
  } = usePlanQuizState();
  const recommendedTierName = useMemo(() => {
    if (!recommendation) {
      return undefined;
    }
    const tierName = getRecommendedTierName(recommendation);
    return isHsocTierName(tierName) ? tierName : undefined;
  }, [recommendation]);
  const badgesByTierName = useMemo(() => resolveHsocCardBadges({
    tiers,
    serverBadgeNameByApiName: {},
    limitedTimeOfferDiscountByTierName,
    recommendedTierName
  }), [tiers, limitedTimeOfferDiscountByTierName, recommendedTierName]);
  const cards = useMemo(() => mapProductsByTierToCards(productsByTier, currencyCode, selectedTerm, badgesByTierName), [productsByTier, currencyCode, selectedTerm, badgesByTierName]);
  const showTermToggle = useMemo(() => hasMultipleBillingTerms(productsByTier), [productsByTier]);
  return {
    cards,
    showTermToggle
  };
}